var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bottom-menu",
      class: { "is-double": _vm.isDouble, "is-open": _vm.is_open }
    },
    [
      _c(
        "div",
        { staticClass: "bottom-menu-container" },
        [
          _vm.isEstatesList
            ? _c("estates-list-menu", {
                attrs: { search: _vm.search, title: _vm.title }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isEstateDetail
            ? _c("estate-detail-menu", {
                attrs: { estate: _vm.estate, config_estate: _vm.config_estate }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isDouble
            ? _c("div", { staticClass: "divider", on: { click: _vm.toggle } }, [
                _c("div", { staticClass: "divider-glyph" })
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      !_vm.showcase
        ? _c("user-menu", { attrs: { config_footer: _vm.config_footer } })
        : _vm._e(),
      _vm._v(" "),
      _vm.isEstatesList && _vm.lang
        ? _c(
            "modal",
            {
              ref: "save_search",
              attrs: {
                name: "save_search",
                title: _vm.lang.estates_list_menu.titles.save_search,
                "extra-class": "bottom-modal save-search-modal"
              }
            },
            [
              _c(
                "template",
                { slot: "body" },
                [
                  _c("save-search-form", {
                    attrs: {
                      search: _vm.estatesFilters,
                      title: _vm.title_search,
                      map_center: _vm.map_center,
                      map_polygons: _vm.map_polygons
                    }
                  })
                ],
                1
              )
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }